const getPath = (urlString = '') => {
  const urlObject = new URL(urlString);

  return urlObject?.pathname ?? '';
};

export default getPath;
